// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.decoration-image {
  position: absolute;
  z-index: 1;
  width: 100%;
}
.decoration-image figure {
  width: 100%;
}

.decoration-image-desktop {
  display: none !important;
}

.srprs-section {
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
}
.srprs-section > .wrapper-inner {
  position: relative;
  margin: 0 auto;
  width: calc(100% - 40px);
  max-width: 1140px;
}
.srprs-section:only-of-type {
  min-height: 400px;
  padding-bottom: 120px;
}
.srprs-header + div > .srprs-section:first-child {
  padding-top: 84px;
}
.srprs-section > .background-image {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  z-index: 0;
  background-repeat: no-repeat;
}
.srprs-section > .background-image.blur-mobile {
  filter: blur(10px);
}
.srprs-section .left-pattern,
.srprs-section .right-pattern {
  position: absolute;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  transform: scale(0.5);
  z-index: 0;
  background-origin: content-box;
  background-repeat: no-repeat;
  padding-top: 160px;
}
.srprs-section .bottom-pattern {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 30px;
  left: 0;
  z-index: 1;
  background-position: bottom;
  background-repeat: repeat-x;
}
.srprs-section .giftcard-bottom-pattern {
  top: 0;
  height: 30px;
  z-index: 1;
}
.srprs-section .thanksgiving-giftcard-bottom-pattern {
  top: 0;
  height: 40px;
  background-color: var(--colorBackground);
  background-size: contain;
  z-index: 1;
}
.srprs-section .left-pattern {
  display: none;
}
.srprs-section .right-pattern {
  right: 0;
  width: 400%;
  height: 400%;
  top: -150%;
  left: -150%;
  transform: scale(0.25);
  padding-top: 1900px;
  background-position: right top;
}
.srprs-section.type-solid {
  background-color: var(--colorBackground);
  color: var(--colorForegroundAccent);
}
.srprs-section.type-solid + .srprs-section.type-solid {
  padding-top: 0;
}
.srprs-section.type-solid-pink {
  background-color: pink;
  color: #0d2c6c;
}
.srprs-section.type-solid + .srprs-section.type-solid-pink {
  padding-top: 0;
}
.srprs-section.type-solid-turquoise, .srprs-section.type-solid-light-pink {
  padding-bottom: 0;
  color: #222;
}
.srprs-section.type-solid + .srprs-section.type-solid-turquoise, .srprs-section.type-solid + .srprs-section.type-solid-light-pink {
  padding-top: 0;
}
.srprs-section.type-solid-turquoise {
  background-color: #1ececa;
}
.srprs-section.type-solid-light-pink {
  background-color: #f0c5ce;
}
.srprs-section.type-pattern {
  background-attachment: scroll;
  background-repeat: repeat;
  background-size: 45%;
  background-color: #fff;
}
.srprs-section.type-background {
  background-size: cover;
  background-position: center center;
  color: #fff;
}
.srprs-section.type-transparent-color .wrapper-inner, .srprs-section.type-transparent-white .wrapper-inner {
  padding: 8px 10px;
  background-color: rgba(255, 255, 255, 0.5);
  color: black;
}
.srprs-section.transparent-white + .srprs-section.type-transparent-color, .srprs-section.transparent-white + .srprs-section.type-transparent-white {
  padding-top: 0;
}
.srprs-section.type-white-message, .srprs-section.type-white {
  background-color: #fff;
}
.srprs-section.type-white + .srprs-section.type-white-message, .srprs-section.type-white + .srprs-section.type-white {
  padding-top: 0;
}
.srprs-section.type-grey {
  background-color: #F5F5F5;
}
.srprs-section.type-grey + .srprs-section.type-grey {
  padding-top: 0;
}
.srprs-section.type-video, .srprs-section.type-photo {
  height: 150vw;
  padding: 0;
}
.srprs-section.type-photo {
  display: flex;
  align-items: center;
  justify-content: center;
}
.srprs-section.type-photo > .srprs-photo {
  position: absolute;
  z-index: 0;
}
.srprs-section.type-photo .srprs-heading {
  font-weight: 800;
}
.srprs-section.type-photo .srprs-list {
  font-weight: 500;
}
.srprs-section.no-padding {
  padding-top: 0;
  padding-bottom: 0;
}
.srprs-section.no-bottom-padding {
  padding-bottom: 0;
}
.srprs-section.size-full-width > .wrapper-inner {
  max-width: 100vw;
  width: 100%;
}
.srprs-section.has-border-bottom > .wrapper-inner {
  padding-bottom: 70px;
  border-width: 0 0 1px;
  border-style: solid;
  border-color: #e7e7e7;
}
.srprs-section.no-overflow {
  width: 100vw;
  overflow-x: hidden;
}
.srprs-section > .wrapper-inner {
  z-index: 1;
}
@supports (padding: max(0px)) {
  .srprs-section > .wrapper-inner {
    padding-left: calc(constant(safe-area-inset-left));
    padding-right: calc(constant(safe-area-inset-right));
  }
}
.srprs-section.type-message {
  position: relative;
  z-index: 10;
  padding-top: 45px;
  padding-bottom: 47px;
  background-color: #FF938C;
}
.srprs-section.type-message + .srprs-section.type-message {
  padding-top: 0;
}
.srprs-section.section-color-rose {
  background-color: #FFE4DE;
}
.srprs-section.section-color-rose > .wrapper-inner {
  max-width: 926px;
}
.srprs-section.section-color-almond {
  background-color: #F3D5CE;
}
.srprs-section.section-color-almond.size-m > .wrapper-inner {
  max-width: 796px;
}
.srprs-section.section-color-blue {
  background-color: #0442F1;
}
.srprs-section.section-color-light-tomato {
  background-color: #FF938C;
}
.srprs-section.section-color-coral {
  background-color: #F5661C;
}
.srprs-section.section-color-morning-glory {
  background-color: #91D1DA;
}
.srprs-section.section-color-cinderella {
  background-color: #FDE2DA;
}
.srprs-section.gift-card-faq-section {
  padding-top: 270px !important;
}
.srprs-section.thanksgiving-card-faq-section {
  padding-top: 170px !important;
}
.srprs-section.giftcard-redeem-card .srprs-cardStory {
  margin-top: 20px;
  box-shadow: none;
}
.srprs-section.giftcard-redeem-card.thanksgiving-redeem-card .srprs-cardStory {
  margin-top: 20px;
  box-shadow: none;
}

@media screen and (min-width: 375px) {
  .srprs-section.thanksgiving-card-faq-section {
    padding-top: 270px !important;
  }
}
@media screen and (min-width: 768px) {
  .srprs-section {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .srprs-section > .background-image.blur-mobile {
    filter: blur(0px);
  }
  .srprs-section .left-pattern {
    display: initial;
  }
  .srprs-section .right-pattern {
    width: 200%;
    height: 200%;
    top: -50%;
    left: -50%;
    transform: scale(0.5);
    padding-top: 280px;
  }
  .srprs-section.type-solid-turquoise, .srprs-section.type-solid-light-pink {
    padding-bottom: inherit;
  }
  .srprs-section.type-transparent-color .wrapper-inner, .srprs-section.type-transparent-white .wrapper-inner {
    padding: 0;
    background: none;
    color: inherit;
  }
  .srprs-section.type-transparent-white {
    background: white;
  }
  .srprs-section.type-transparent-white .wrapper-inner {
    background: white;
  }
  .srprs-section.type-video, .srprs-section.type-photo {
    height: 50vw;
  }
  .srprs-section:only-of-type {
    min-height: 600px;
    padding-bottom: 140px;
  }
  .srprs-section.home-stats-gap {
    padding-top: 15px;
  }
  .srprs-section.bottom-pattern {
    height: 60px;
  }
  .srprs-section.thanksgiving-giftcard-bottom-pattern {
    height: 70px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-section {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .srprs-section:only-of-type {
    padding-bottom: 140px;
    height: calc(100% - 384px);
  }
  .srprs-section.size-xs > .wrapper-inner {
    max-width: 706px;
  }
  .srprs-section.size-s > .wrapper-inner {
    max-width: 880px;
  }
  .srprs-section.size-m > .wrapper-inner {
    max-width: 1010px;
  }
  .srprs-section.size-l > .wrapper-inner {
    max-width: 1280px;
  }
  .srprs-section.size-xl > .wrapper-inner {
    max-width: none;
    margin-left: 6vw;
    margin-right: 6vw;
  }
  .srprs-section.size-full-width > .wrapper-inner {
    max-width: 100vw;
    width: 100%;
  }
  .srprs-section.type-white-message, .srprs-section.type-message {
    padding-left: 75px;
    padding-right: 75px;
    padding-top: 51px;
    padding-bottom: 74px;
  }
  .srprs-section.bottom-pattern {
    height: 60px;
  }
  .srprs-section .thanksgiving-giftcard-bottom-pattern {
    height: 60px;
  }
  .srprs-section.thanksgiving-card-faq-section {
    padding-top: 230px !important;
  }
}
@media screen and (min-width: 1280px) {
  .decoration-image-desktop {
    display: block !important;
    position: absolute;
    z-index: 2;
    width: 100%;
    transition: width 0.3s;
  }
  .decoration-image-desktop.is-covered {
    z-index: 0;
  }
  .decoration-image-desktop figure {
    width: 100%;
  }
  .decoration-image-desktop .thanksgiving-giftcard-trigger {
    display: flex;
    align-items: center;
    background-color: #c5eff4;
    height: 86px;
    line-height: 86px;
    box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5);
  }
  .decoration-image-desktop .thanksgiving-giftcard-trigger picture {
    position: relative;
    top: 15px;
  }
  .decoration-image-desktop .thanksgiving-giftcard-trigger-opened {
    padding-left: 5px;
    padding-right: 24px;
  }
  .srprs-section {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .srprs-section.type-video, .srprs-section.type-photo {
    height: 25vw;
  }
  .srprs-section:only-of-type {
    height: calc(100% - 394px);
    min-height: 700px;
    padding-bottom: 140px;
  }
  .srprs-header:not(.is-funnel) + div > .srprs-section:first-child {
    padding-top: 200px;
  }
  .srprs-header.is-funnel + div > .srprs-section:first-child {
    padding-top: 146px;
  }
  .srprs-section.type-white-message, .srprs-section.type-message {
    padding-top: 90px;
    padding-bottom: 90px;
  }
  .srprs-section.gift-card-footer-section > .wrapper-inner {
    padding-top: 85px;
  }
  .srprs-section.gift-card-faq-section {
    padding-top: 300px !important;
  }
  .srprs-section.giftcard-decoration-images-header.thanksgiving-giftcard-header {
    padding-bottom: 40px !important;
  }
  .srprs-section.giftcard-decoration-images-header .decoration-image-desktop {
    z-index: 1;
  }
  .srprs-section.thanksgiving-card-tab {
    padding-top: 48px;
  }
  .srprs-section.thanksgiving-redeem-card .srprs-cardStory {
    margin-top: 160px;
  }
  .srprs-section .bottom-pattern {
    height: 15%;
  }
  .srprs-section .thanksgiving-giftcard-bottom-pattern {
    height: 210px;
    background-size: initial;
  }
  .srprs-section.giftcard-redeem-card.thanksgiving-redeem-card .srprs-cardStory {
    margin-top: 160px;
    box-shadow: none;
  }
  .srprs-section.thanksgiving-card-faq-section {
    padding-top: 350px !important;
  }
}
@media screen and (min-width: 1600px) {
  .srprs-section.size-initial-expand > .wrapper-inner {
    max-width: 1530px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Section/Section.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_wrapper-inner.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_iphonex.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AAuMF;AArME;EACE,WAAA;AAuMJ;;AApMA;EACE,wBAAA;AAuMF;;AArMA;EAGE,kBAAA;EAEE,iBAAA;EACA,oBAAA;AAqMJ;AIxNE;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAIE,iBAAA;AJuNN;AAzME;EACE,iBAAA;EACA,qBAAA;AA2MJ;AAzME;EAEI,iBAAA;AA0MN;AAvME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,4BAAA;AAyMJ;AAvMI;EACE,kBAAA;AAyMN;AArME;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,UAAA;EAEE,8BAAA;EACA,4BAAA;EAEF,kBAAA;AAqMJ;AAnME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EAEE,2BAAA;EACA,2BAAA;AAoMN;AAjME;EACE,MAAA;EACA,YAAA;EACA,UAAA;AAmMJ;AAjME;EACE,MAAA;EACA,YAAA;EACA,wCAAA;EACA,wBAAA;EACA,UAAA;AAmMJ;AAjME;EACE,aAAA;AAmMJ;AAjME;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EAEE,8BAAA;AAkMN;AA/LE;EAEI,wCAAA;EAEF,mCAAA;AA+LJ;AA9LI;EACE,cAAA;AAgMN;AA7LE;EAEI,sBAAA;EAEF,cAAA;AA6LJ;AA5LI;EACE,cAAA;AA8LN;AA3LE;EAGI,iBAAA;EAEF,WAAA;AA0LJ;AAzLI;EACE,cAAA;AA2LN;AAxLE;EAEI,yBAAA;AAyLN;AAtLE;EAEI,yBAAA;AAuLN;AApLE;EAEI,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AAqLN;AAlLE;EAEI,sBAAA;EACA,kCAAA;EAEF,WAAA;AAkLJ;AA9KI;EACE,iBAAA;EAEE,0CAAA;EAEF,YAAA;AA8KN;AA5KI;EACE,cAAA;AA8KN;AA3KE;EAGI,sBAAA;AA2KN;AAzKI;EACE,cAAA;AA2KN;AAxKE;EAEI,yBAAA;AAyKN;AAvKI;EACE,cAAA;AAyKN;AAtKE;EAEE,aAAA;EACA,UAAA;AAuKJ;AArKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAuKJ;AAtKI;EACE,kBAAA;EACA,UAAA;AAwKN;AAtKI;EACE,gBAAA;AAwKN;AAtKI;EACE,gBAAA;AAwKN;AArKE;EAEI,cAAA;EACA,iBAAA;AAsKN;AAnKE;EAEI,iBAAA;AAoKN;AAhKI;EACE,gBAAA;EACA,WAAA;AAkKN;AA9JI;EAEI,oBAAA;EAGA,qBAAA;EACA,mBAAA;EACA,qBAAA;AA6JR;AAzJE;EACE,YAAA;EACA,kBAAA;AA2JJ;AAzJE;EAEE,UAAA;AA0JJ;AKzYE;EL6OA;IK3OI,kDAAA;IACA,oDAAA;EL2YJ;AACF;AA9JE;EACE,kBAAA;EACA,WAAA;EAEE,iBAAA;EACA,oBAAA;EAGA,yBAAA;AA6JN;AA3JI;EACE,cAAA;AA6JN;AA1JE;EACE,yBAAA;AA4JJ;AA3JI;EACE,gBAAA;AA6JN;AA1JE;EACE,yBAAA;AA4JJ;AA1JM;EACE,gBAAA;AA4JR;AAxJE;EACE,yBAAA;AA0JJ;AAxJE;EACE,yBAAA;AA0JJ;AAxJE;EACE,yBAAA;AA0JJ;AAxJE;EACE,yBAAA;AA0JJ;AAxJE;EACE,yBAAA;AA0JJ;AAxJE;EACE,6BAAA;AA0JJ;AAxJE;EACE,6BAAA;AA0JJ;AAvJI;EACE,gBAAA;EACA,gBAAA;AAyJN;AAtJM;EACE,gBAAA;EACA,gBAAA;AAwJR;;AC9bI;ED8SA;IACE,6BAAA;EAoJJ;AACF;ACpcI;EDqTF;IAOI,iBAAA;IACA,oBAAA;EA4IJ;EAlJI;IACE,iBAAA;EAoJN;EA7IE;IACE,gBAAA;EA+IJ;EA7IE;IACE,WAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IACA,qBAAA;IACA,kBAAA;EA+IJ;EA5IE;IAGI,uBAAA;EA4IN;EAvII;IACE,UAAA;IACA,gBAAA;IACA,cAAA;EAyIN;EAtIE;IACE,iBAAA;EAwIJ;EAvII;IACE,iBAAA;EAyIN;EAtIE;IAEE,YAAA;EAuIJ;EArIE;IACE,iBAAA;IACA,qBAAA;EAuIJ;EApIE;IACE,iBAAA;EAsIJ;EApIE;IACE,YAAA;EAsIJ;EApIE;IACE,YAAA;EAsIJ;AACF;ACtfI;EDqXF;IAEI,iBAAA;IACA,oBAAA;EAmIJ;EAjIE;IACE,qBAAA;IACA,0BAAA;EAmIJ;EAhII;IACE,gBAAA;EAkIN;EA9HI;IACE,gBAAA;EAgIN;EA5HI;IACE,iBAAA;EA8HN;EA1HI;IACE,iBAAA;EA4HN;EAxHI;IACE,eAAA;IAEE,gBAAA;IACA,iBAAA;EAyHR;EApHI;IACE,gBAAA;IACA,WAAA;EAsHN;EAnHE;IAGI,kBAAA;IACA,mBAAA;IACA,iBAAA;IACA,oBAAA;EAmHN;EAhHE;IACE,YAAA;EAkHJ;EAhHE;IACE,YAAA;EAkHJ;EAhHE;IACE,6BAAA;EAkHJ;AACF;ACpiBI;EDubF;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,WAAA;IACA,sBAAA;EAgHF;EA9GE;IACE,UAAA;EAgHJ;EA9GE;IACE,WAAA;EAgHJ;EA9GE;IACE,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,YAAA;IACA,iBAAA;IACA,0CAAA;EAgHJ;EA/GI;IACE,kBAAA;IACA,SAAA;EAiHN;EA9GE;IAEI,iBAAA;IACA,mBAAA;EA+GN;EA1GA;IAEI,iBAAA;IACA,oBAAA;EA2GJ;EAzGE;IAEE,YAAA;EA0GJ;EAxGE;IACE,0BAAA;IACA,iBAAA;IACA,qBAAA;EA0GJ;EAxGE;IAEI,kBAAA;EAyGN;EAtGE;IACE,kBAAA;EAwGJ;EAtGE;IAGI,iBAAA;IACA,oBAAA;EAsGN;EAlGI;IACE,iBAAA;EAoGN;EAjGE;IACE,6BAAA;EAmGJ;EAhGI;IACE,+BAAA;EAkGN;EAhGI;IACE,UAAA;EAkGN;EA/FE;IACE,iBAAA;EAiGJ;EA9FI;IACE,iBAAA;EAgGN;EA7FE;IACE,WAAA;EA+FJ;EA7FE;IACE,aAAA;IACA,wBAAA;EA+FJ;EA3FM;IACE,iBAAA;IACA,gBAAA;EA6FR;EAzFE;IACE,6BAAA;EA2FJ;AACF;ACznBI;EDoiBA;IACE,iBAAA;EAwFJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.decoration-image {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n\n  figure {\n    width: 100%;\n  }\n}\n.decoration-image-desktop {\n  display: none !important;\n}\n.srprs-section {\n  @include wrapper-inner();\n\n  position: relative;\n  padding: {\n    top: section(padding-initial);\n    bottom: section(padding-initial);\n  }\n  &:only-of-type {\n    min-height: 400px;\n    padding-bottom: 120px;\n  }\n  .srprs-header + div > &:first-child {\n    padding: {\n      top: 84px; // 24px + 60px\n    }\n  }\n  > .background-image {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    background-repeat: no-repeat;\n\n    &.blur-mobile {\n      filter: blur(10px);\n    }\n  }\n\n  .left-pattern,\n  .right-pattern {\n    position: absolute;\n    width: 200%;\n    height: 200%;\n    top: -50%;\n    left: -50%;\n    transform: scale(0.5);\n    z-index: 0;\n    background: {\n      origin: content-box;\n      repeat: no-repeat;\n    }\n    padding-top: 160px;\n  }\n  .bottom-pattern {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    height: 30px;\n    left: 0;\n    z-index: 1;\n    background: {\n      position: bottom;\n      repeat: repeat-x;\n    }\n  }\n  .giftcard-bottom-pattern {\n    top: 0;\n    height: 30px;\n    z-index: 1;\n  }\n  .thanksgiving-giftcard-bottom-pattern {\n    top: 0;\n    height: 40px;\n    background-color: var(--colorBackground);\n    background-size: contain;\n    z-index: 1;\n  }\n  .left-pattern {\n    display: none;\n  }\n  .right-pattern {\n    right: 0;\n    width: 400%;\n    height: 400%;\n    top: -150%;\n    left: -150%;\n    transform: scale(0.25);\n    padding-top: 1900px;\n    background: {\n      position: right top;\n    }\n  }\n  &.type-solid {\n    background: {\n      color: var(--colorBackground);\n    }\n    color: var(--colorForegroundAccent);\n    .srprs-section.type-solid + & {\n      padding-top: 0;\n    }\n  }\n  &.type-solid-pink {\n    background: {\n      color: pink;\n    }\n    color: #0d2c6c;\n    .srprs-section.type-solid + & {\n      padding-top: 0;\n    }\n  }\n  &.type-solid-turquoise,\n  &.type-solid-light-pink {\n    padding: {\n      bottom: 0;\n    }\n    color: color(black);\n    .srprs-section.type-solid + & {\n      padding-top: 0;\n    }\n  }\n  &.type-solid-turquoise {\n    background: {\n      color: color(turquoise);\n    }\n  }\n  &.type-solid-light-pink {\n    background: {\n      color: color(pink-light);\n    }\n  }\n  &.type-pattern {\n    background: {\n      attachment: scroll;\n      repeat: repeat;\n      size: 45%;\n      color: color(white);\n    }\n  }\n  &.type-background {\n    background: {\n      size: cover;\n      position: center center;\n    }\n    color: color(white);\n  }\n  &.type-transparent-color,\n  &.type-transparent-white {\n    .wrapper-inner {\n      padding: 8px 10px;\n      background: {\n        color: transparentize(color(white), 0.5);\n      }\n      color: black;\n    }\n    .srprs-section.transparent-white + & {\n      padding-top: 0;\n    }\n  }\n  &.type-white-message,\n  &.type-white {\n    background: {\n      color: color(white);\n    }\n    .srprs-section.type-white + & {\n      padding-top: 0;\n    }\n  }\n  &.type-grey {\n    background: {\n      color: color(grey-lightest);\n    }\n    .srprs-section.type-grey + & {\n      padding-top: 0;\n    }\n  }\n  &.type-video,\n  &.type-photo {\n    height: calc(100vw * 1.5);\n    padding: 0;\n  }\n  &.type-photo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    & > .srprs-photo {\n      position: absolute;\n      z-index: 0;\n    }\n    & .srprs-heading {\n      font-weight: 800;\n    }\n    & .srprs-list {\n      font-weight: 500;\n    }\n  }\n  &.no-padding {\n    padding: {\n      top: 0;\n      bottom: 0;\n    }\n  }\n  &.no-bottom-padding {\n    padding: {\n      bottom: 0;\n    }\n  }\n  &.size-full-width {\n    > .wrapper-inner {\n      max-width: 100vw;\n      width: 100%;\n    }\n  }\n  &.has-border-bottom {\n    > .wrapper-inner {\n      padding: {\n        bottom: 70px;\n      }\n      border: {\n        width: 0 0 1px;\n        style: solid;\n        color: color(grey-light);\n      }\n    }\n  }\n  &.no-overflow {\n    width: 100vw;\n    overflow-x: hidden;\n  }\n  > .wrapper-inner {\n    @include iphonex();\n    z-index: 1;\n  }\n  &.type-message {\n    position: relative;\n    z-index: 10;\n    padding: {\n      top: 45px;\n      bottom: 47px;\n    }\n    background: {\n      color: color(tomato-section);\n    }\n    .srprs-section.type-message + & {\n      padding-top: 0;\n    }\n  }\n  &.section-color-rose {\n    background-color: color(rose);\n    > .wrapper-inner {\n      max-width: 926px;\n    }\n  }\n  &.section-color-almond {\n    background-color: color(almond);\n    &.size-m {\n      > .wrapper-inner {\n        max-width: 796px;\n      }\n    }\n  }\n  &.section-color-blue {\n    background-color: color(navy-blue);\n  }\n  &.section-color-light-tomato {\n    background-color: color(tomato-section);\n  }\n  &.section-color-coral {\n    background-color: color(coral);\n  }\n  &.section-color-morning-glory {\n    background-color: color(morning-glory);\n  }\n  &.section-color-cinderella {\n    background-color: color(cinderella);\n  }\n  &.gift-card-faq-section {\n    padding-top: 270px !important;\n  }\n  &.thanksgiving-card-faq-section {\n    padding-top: 170px !important;\n  }\n  &.giftcard-redeem-card {\n    .srprs-cardStory {\n      margin-top: 20px;\n      box-shadow: none;\n    }\n    &.thanksgiving-redeem-card {\n      .srprs-cardStory {\n        margin-top: 20px;\n        box-shadow: none;\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-section {\n    &.thanksgiving-card-faq-section {\n      padding-top: 270px !important;\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-section {\n    > .background-image {\n      &.blur-mobile {\n        filter: blur(0px);\n      }\n    }\n    padding: {\n      top: section(padding-tablet-portrait);\n      bottom: section(padding-tablet-portrait);\n    }\n    .left-pattern {\n      display: initial;\n    }\n    .right-pattern {\n      width: 200%;\n      height: 200%;\n      top: -50%;\n      left: -50%;\n      transform: scale(0.5);\n      padding-top: 280px;\n    }\n\n    &.type-solid-turquoise,\n    &.type-solid-light-pink {\n      padding: {\n        bottom: inherit;\n      }\n    }\n    &.type-transparent-color,\n    &.type-transparent-white {\n      .wrapper-inner {\n        padding: 0;\n        background: none;\n        color: inherit;\n      }\n    }\n    &.type-transparent-white {\n      background: white;\n      .wrapper-inner {\n        background: white;\n      }\n    }\n    &.type-video,\n    &.type-photo {\n      height: calc(100vw / 2);\n    }\n    &:only-of-type {\n      min-height: 600px;\n      padding-bottom: 140px;\n    }\n\n    &.home-stats-gap {\n      padding-top: 15px;\n    }\n    &.bottom-pattern {\n      height: 60px;\n    }\n    &.thanksgiving-giftcard-bottom-pattern {\n      height: 70px;\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-section {\n    padding: {\n      top: section(padding-tablet-landscape);\n      bottom: section(padding-tablet-landscape);\n    }\n    &:only-of-type {\n      padding-bottom: 140px;\n      height: calc(100% - 384px);\n    }\n    &.size-xs {\n      > .wrapper-inner {\n        max-width: section(max-width-xs);\n      }\n    }\n    &.size-s {\n      > .wrapper-inner {\n        max-width: section(max-width-s);\n      }\n    }\n    &.size-m {\n      > .wrapper-inner {\n        max-width: section(max-width-m);\n      }\n    }\n    &.size-l {\n      > .wrapper-inner {\n        max-width: section(max-width-l);\n      }\n    }\n    &.size-xl {\n      > .wrapper-inner {\n        max-width: none;\n        margin: {\n          left: 6vw;\n          right: 6vw;\n        }\n      }\n    }\n    &.size-full-width {\n      > .wrapper-inner {\n        max-width: 100vw;\n        width: 100%;\n      }\n    }\n    &.type-white-message,\n    &.type-message {\n      padding: {\n        left: 75px;\n        right: 75px;\n        top: 51px;\n        bottom: 74px;\n      }\n    }\n    &.bottom-pattern {\n      height: 60px;\n    }\n    .thanksgiving-giftcard-bottom-pattern {\n      height: 60px;\n    }\n    &.thanksgiving-card-faq-section {\n      padding-top: 230px !important;\n    }\n  }\n}\n\n@include breakpoint(desktop) {\n  .decoration-image-desktop {\n    display: block !important;\n    position: absolute;\n    z-index: 2;\n    width: 100%;\n    transition: width 0.3s;\n\n    &.is-covered {\n      z-index: 0;\n    }\n    figure {\n      width: 100%;\n    }\n    .thanksgiving-giftcard-trigger {\n      display: flex;\n      align-items: center;\n      background-color: #c5eff4;\n      height: 86px;\n      line-height: 86px;\n      box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.5);\n      picture {\n        position: relative;\n        top: 15px;\n      }\n    }\n    .thanksgiving-giftcard-trigger-opened {\n      padding: {\n        left: 5px;\n        right: 24px;\n      }\n    }\n  }\n\n  .srprs-section {\n    padding: {\n      top: section(padding-desktop);\n      bottom: section(padding-desktop);\n    }\n    &.type-video,\n    &.type-photo {\n      height: calc(100vw / 4);\n    }\n    &:only-of-type {\n      height: calc(100% - 394px);\n      min-height: 700px;\n      padding-bottom: 140px;\n    }\n    .srprs-header:not(.is-funnel) + div > &:first-child {\n      padding: {\n        top: 200px;\n      }\n    }\n    .srprs-header.is-funnel + div > &:first-child {\n      padding-top: 146px; // 96px + 50px\n    }\n    &.type-white-message,\n    &.type-message {\n      padding: {\n        top: 90px;\n        bottom: 90px;\n      }\n    }\n    &.gift-card-footer-section {\n      > .wrapper-inner {\n        padding-top: 85px;\n      }\n    }\n    &.gift-card-faq-section {\n      padding-top: 300px !important;\n    }\n    &.giftcard-decoration-images-header {\n      &.thanksgiving-giftcard-header {\n        padding-bottom: 40px !important;\n      }\n      .decoration-image-desktop {\n        z-index: 1;\n      }\n    }\n    &.thanksgiving-card-tab {\n      padding-top: 48px;\n    }\n    &.thanksgiving-redeem-card {\n      .srprs-cardStory {\n        margin-top: 160px;\n      }\n    }\n    .bottom-pattern {\n      height: 15%;\n    }\n    .thanksgiving-giftcard-bottom-pattern {\n      height: 210px;\n      background-size: initial;\n    }\n    &.giftcard-redeem-card {\n      &.thanksgiving-redeem-card {\n        .srprs-cardStory {\n          margin-top: 160px;\n          box-shadow: none;\n        }\n      }\n    }\n    &.thanksgiving-card-faq-section {\n      padding-top: 350px !important;\n    }\n  }\n}\n\n@include breakpoint(cinemadisplay) {\n  .srprs-section.size-initial-expand {\n    > .wrapper-inner {\n      max-width: 1530px;\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin wrapper-inner($max-width: '') {\n  > .wrapper-inner {\n    position: relative;\n    margin: 0 auto;\n    width: calc(100% - 40px);\n    @if $max-width != '' {\n      max-width: ($max-width);\n    } @else {\n      max-width: 1140px;\n    }\n  }\n}\n","@mixin iphonex {\n  // reference: https://forum.vuejs.org/t/getting-css-ready-for-iphone-x/25212/5\n  @supports (padding: max(0px)) {\n    padding: {\n      left: calc(constant(safe-area-inset-left));\n      right: calc(constant(safe-area-inset-right));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
